
import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'

import ActivityForm from '../components/ActivityCreateForm.vue'
import PageHeader from '@/domains/global/components/PageHeader.vue'
import { consumeError } from '@/domains/global/utils'
import { TranslationActivity, TranslationService, TranslationServiceCosts, TranslationServiceTemplate } from '@/domains/global/models'

@Component({
  components: { ActivityForm, PageHeader }
})
export default class NewActivityPage extends Vue {
  job: any =  {}
  startingPrices: Partial<TranslationServiceCosts> = {}
  templates: TranslationServiceTemplate[] = []
  fee: any = {}
  templateId: string | null = null
  documentType: string | null = null

  get jobId() {
    return this.$route.params.id
  }

  async mounted() {
    if (this.$route.query.templateId) {
      this.templateId = this.$route.query.templateId as string
    }

    if (this.$route.query.documentType) {
      this.documentType = this.$route.query.documentType as string
    }

    await this.getJob()
    await this.getFee()
    if (this.job) {
      this.getStartingPrices()
    }
  }

  async getJob() {
    const response = await axios.get(`/jobs/${this.jobId}`)
    this.job = response.data
  }

  async getFee() {
    const response = await axios.get('/jobs/service-fee')
    this.fee = response.data
  }

  async getStartingPrices() {
    const response = await axios.get<TranslationService>(`/jobs/${this.jobId}/service-costs/${this.job.languageId}`)
    const service = response.data
    if (!service) {
      return
    }
    this.startingPrices = {
      ...service.costs
    }
    this.templates = service.templates || []
  }

  async createActivity(data: any) {
    const formData = new FormData()
    if (data.templateId) {
      formData.append('templateId', data.templateId)
    }
    formData.append('type', data.type)
    try {
      const response = await axios.post<TranslationActivity>(`/jobs/${this.jobId}/activities`, formData)
      this.$router.push(`/jobs/${this.jobId}/activities/${response.data.id}/translate`)
    } catch (error) {
      const formattedError = consumeError(error as any)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
